<template>
  <AppDialog
    :is-open="isDialogOpened"
    size="m"
    hide-footer
    @cancel="closeDialog"
  >
    <template #title>
      <div class="mt-2 mb-2">
        {{ $t('common.app-bar.AppBarRoomBreadcrumbMobileDialog.title') }}
      </div>
    </template>

    <template #body>
      <v-divider class="text-grey-200 ms-n3 me-n3" :opacity="1" />
      <v-card class="pa-0 mt-8 ml-3 mr-3 mb-3 rounded-lg content-card" elevation="0" border>
        <v-list class="pa-0" density="comfortable">
          <div v-for="(folder, index) in folders" :key="index">
            <v-list-item @click="folder.onClick">
              <div class="d-flex flex-row align-center mt-4 mb-4">
                <app-material-icon v-if="index !== 0" class="mr-3" name="arrow-turn-down-right" type="fa" size="sm" />
                <app-material-icon v-if="folder.type === 'root'" class="mr-2" name="rectangle-history" type="fa" size="sm" />
                <app-material-icon v-else-if="folder.type === 'folder'" class="mr-2" name="folder" type="fa" size="sm" />
                <span class="text-grey-700 text-truncate">
                {{ folder.title }}
              </span>
              </div>
            </v-list-item>
            <v-divider class="text-grey-200" :opacity="1" />
          </div>

          <v-list-item class="mt-2 mb-2">
            <div class="d-flex flex-row align-center">
              <app-material-icon class="mr-3" name="arrow-turn-down-right" type="fa" size="sm" />
              <RoomTypeIcon
                class="mr-2"
                :room="{ isDataroom: room.isDataroom }"
                :width="19"
              />
              <AppTooltip
                :max-width="MAX_TOOLTIP_WIDTH"
                location="bottom"
              >
                <template #activator="{ props }">
                  <span
                    class="text-grey-700 text-truncate"
                    v-bind="props"
                  >
                    {{ room.name }}
                  </span>
                </template>
                {{ room.name }}
              </AppTooltip>
            </div>
          </v-list-item>

          <v-divider class="text-grey-200" :opacity="1" />

          <v-list-item class="mt-2 mb-2">
            <div class="d-flex flex-row align-center">
              <app-material-icon class="mr-3 cursor-default" name="arrow-turn-down-right" type="fa" size="sm" />
              <app-icon-ds
                :icon="navigationPage.icon"
                size="sm"
                class="mr-2"
              />
              <span class="text-grey-700 text-truncate">
                {{ $t(`${NAVIGATION_TRANSLATION_KEY_PREFIX}.${navigationPage.translationKey}`) }}
              </span>
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
  </AppDialog>
</template>

<script lang="ts">
import { PropType } from "vue"

import { Crumb, NavigationDataPage, Room } from "@/common/app-bar/AppBarRoomBreadcrumb.vue"
import AppDialog from '@/common/dialogs/AppDialog.vue'
import RoomTypeIcon from '@/common/RoomTypeIcon.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

import AppTooltip from "../AppTooltip.vue"

const MAX_TOOLTIP_WIDTH = 600
const NAVIGATION_TRANSLATION_KEY_PREFIX = 'project.ProjectNavigationDrawer'

export default {
  name: 'AppBarRoomBreadcrumbMobileDialog',
  emits: ['save', 'discard'],
  components: {
    RoomTypeIcon,
    AppDialog,
    AppTooltip,
  },
  mixins: [dialogMixin],
  props: {
    folders: {
      type: Array as PropType<Array<Crumb>>,
      default: () => [],
    },
    room: {
      type: Object as PropType<Room>,
      required: true,
    },
    navigationPage: {
      type: Object as PropType<NavigationDataPage>,
      required: true,
    },
  },
  data () {
    return {
      MAX_TOOLTIP_WIDTH,
      NAVIGATION_TRANSLATION_KEY_PREFIX,
    }
  },
}
</script>

<style scoped lang="scss">
.content-card {
  border-color: rgb(var(--v-theme-grey-200));
}
</style>
